import { defineComponent, computed } from "vue";
import { u as useTranslation } from "../../composables/useTranslation-389ad6ba.mjs";
import { V as VaButton } from "../va-button/index-e7ff1275.mjs";
const _sfc_main = defineComponent({
  name: "VaStepperControls",
  components: { VaButton },
  props: {
    modelValue: { type: Number, required: true },
    steps: {
      type: Array,
      required: true
    },
    nextDisabled: { type: Boolean, required: true },
    stepControls: { type: Object, required: true },
    finishButtonHidden: { type: Boolean, default: false }
  },
  setup(props) {
    const { t } = useTranslation();
    const isLastStep = computed(() => {
      const lastEnabledStepIndex = props.steps.length - 1;
      return props.modelValue >= lastEnabledStepIndex;
    });
    return {
      t,
      isLastStep
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaStepperControls.css';
//# sourceMappingURL=VaStepperControls.vue_vue_type_script_lang-15a87109.mjs.map
